@if (community && community.code == 'benicassim-activa'){
<div class="colabs2">
    <img class="" src="assets/benicassim-activa/benicassim-activa.png" />
    <img class="" src="assets/benicassim-activa/benicassim-emprenedoria.png" />
</div>
}

<div class="footer" [ngStyle]="{ 'background-color' : community?.colorBackground || community?.color1 }">
    <div class="max-width-wrapper">
        <div class="row">
            <div class="col-md-4 mobile-center">
                <div class="logo mb-3">
                    <ng-container *ngIf="community && community.code != 'gironahostaleria'">
                        <img class="logo positive"
                            [src]="(community.logoHorizontal || community.image || community.logoHorizontalNegative || community.logoNegative) | imageUrl"
                            loading="lazy" />
                        <img class="logo negative"
                            [src]="(community.logoHorizontalNegative || community.logoNegative || community.logoHorizontal || community.image) | imageUrl"
                            loading="lazy" />
                        <!--<span style="margin-left: 1em;">{{community.name}}</span>-->
                    </ng-container>
                    <ng-container *ngIf="community && community.code == 'gironahostaleria'">
                        <img class="gironahostaleria" src="assets/gironahostaleria/logo-blanc-vertical.svg" />
                    </ng-container>
                </div>
            </div>
            <div class="col-md-4 mobile-center">
                <div class="colabs" *ngIf="community && community.code == 'gironahostaleria'">
                    <div class="title">COL·LABORADORS:</div>
                    <div>
                        <img src="assets/gironahostaleria/aj_girona.png" />
                        <img src="assets/gironahostaleria/generalitat.png" />
                    </div>
                </div>
            </div>
            <div class="col-md-4 mobile-center">
                <div class="contact">
                    <!--<div class="title">CONTACTE:</div>-->
                    <!--<div *ngIf="community?.mail">
                        <a href="mailto:{{community.mail}}">{{community.mail}}</a>
                    </div>
                    <div *ngIf="community?.phone">
                        {{community?.phone}}
                    </div>
                    <div *ngIf="community?.locationString">
                        {{community?.locationString}}
                    </div>
                    -->
                    <div *ngIf="community?.code">
                        <div class="legal-info mb-2">
                            @if (community.legalName) { <div>{{community.legalName}}</div> }
                            @if (community.legalNif) { <div>{{community.legalNif}}</div> }
                            <!--@if (community.legalAddress) { <div>{{community.legalAddress}}</div> }-->
                        </div>
                        <a [routerLink]="['/', community.code, 'policies', 'privacy']" target="_blank">{{
                            'FOOTER.LinkPrivacy' |
                            translate }}</a><br />
                        <a [routerLink]="['/', community.code, 'policies', 'cookies']" target="_blank">{{
                            'FOOTER.LinkCookies' |
                            translate }}</a>
                        <span class="cookie-preferences-separator" aria-hidden="true">|</span>
                        <button
                            type="button"
                            class="cookie-preferences-btn"
                            [attr.aria-label]="'FOOTER.ManageCookies' | translate"
                            (click)="openCookiePreferences()">
                            {{ 'FOOTER.Preferences' | translate }}
                        </button><br />
                        <a [routerLink]="['/', community.code, 'policies', 'terms-of-sale']" target="_blank">{{
                            'FOOTER.LinkTermsOfSales' | translate }}</a>
                    </div>
                    <div class="social-icons" *ngIf="community && community.code == 'gironahostaleria'">
                        <a href="https://www.facebook.com/AHTRG"><i class="fa fa-facebook"></i></a>
                        <a href="https://twitter.com/Gi_Hostaleria"><i class="fa fa-twitter"></i></a>
                        <a href="https://www.instagram.com/gironahostaleria/"><i class="fa fa-instagram"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>